// Lib
import { useEffect, useRef } from 'react';

function usePrevious<T>(value: T): T;

/**
 * Returns the value of a variable in the previous render.
 * This is different from the usePreviousDistinctValue hook. That will only update if the rendered value changes, while this one returns the previous render's value even if it's the same.
 */
function usePrevious<T>(value: T, initialValue?: T): T | undefined {
    const ref = useRef(initialValue);
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

export default usePrevious;
